import * as React from "react";
import { useState } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import {
  Button,
  Checkbox,
  Typography,
  TextField,
  Divider,
  FormHelperText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import ProgressBar from "./ProgressBar"
import Chip from "@mui/material/Chip";
// import { uploadCoverApi } from "../../../../../services/subtitlesApi"
import Fab from "@mui/material/Fab";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
// import {
//   customToastify,
//   checkErrorMessage,
//   checkResponseData,
// } from "../../../utils/utilsFunctions";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Pagination from "@mui/material/Pagination";
import VerifiedIcon from "@mui/icons-material/Verified";

export default function ModalSelectCover(props) {
  const {
    searchSubtitle,
    subtitlesListPaginate,
    searchById,
    userTypes,
    handleShowLoginForm,
  } = props;
  const [isSerial, setIsSerial] = useState(false);
  const [nameOfMovie, setNameOfMovie] = useState(null);
  const [episode, setEpisode] = useState(null);
  const [season, setSeason] = useState(null);
  const [subtitlesLanguage, setSubtitlesLanguage] = useState("all");
  const [subtitlesUploadId, setSubtitlesUploadId] = useState("");

  const handleSearchClick = () => {
    if (userTypes.length == 0) {
      handleShowLoginForm(true);
    } else {
      if (searchById)
        searchSubtitle(
          "id",
          { subtitlesUploadId: subtitlesUploadId },
          { page: 1, perPage: 50 }
        );
      else
        searchSubtitle(
          "name",
          { nameOfMovie, episode, season, subtitlesLanguage },
          { page: 1, perPage: 50 }
        );
    }
  };
  const handleChangePage = (event, value) => {
    if (searchById)
      searchSubtitle(
        "id",
        { subtitlesUploadId: subtitlesUploadId },
        { page: value, perPage: 50 }
      );
    else
      searchSubtitle(
        "name",
        { nameOfMovie, episode, season, subtitlesLanguage },
        { page: value, perPage: 50 }
      );
  };
  return (
    <>
      {searchById ? (
        <Paper>
          <Box sx={{ display: "flex", width: " 100%", alignItems: "center" }}>
            <VerifiedIcon />

            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="ای دی زیرنویس"
              inputProps={{ "aria-label": "ای دی زیرنویس" }}
              value={subtitlesUploadId}
              onChange={(e) => {
                setSubtitlesUploadId(e.target.value);
              }}
            />
            <Button
              onClick={handleSearchClick}
              variant="contained"
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
            >
              جست و جو
              <ClosedCaptionIcon sx={{ mx: 1 }} />
            </Button>
          </Box>
        </Paper>
      ) : (
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            mx: "auto",
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
            alignItems: "center",
            width: "95%",
          }}
        >
          <Box sx={{ display: "flex", width: " 100%" }}>
            <IconButton
              onClick={() => {
                if (isSerial) {
                  setEpisode(null);
                  setSeason(null);
                }
                setIsSerial(!isSerial);
              }}
              sx={{ p: "10px" }}
              aria-label="menu"
            >
              {subtitlesLanguage == "all" ? (
                <MenuIcon />
              ) : (
                <Fab size="small">{subtitlesLanguage}</Fab>
              )}
            </IconButton>

            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="نام فیلم یا سریال"
              inputProps={{ "aria-label": "نام فیلم یا سریال" }}
              value={nameOfMovie}
              onChange={(e) => {
                setNameOfMovie(e.target.value);
              }}
            />
            <Button
              onClick={handleSearchClick}
              variant="contained"
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
            >
              جست و جو
              <ClosedCaptionIcon sx={{ mx: 1 }} />
            </Button>
            {/* <Button onClick={()=>{}}></Button> */}
            {/* <ProgressBar percent={10}/> */}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", width: " 100%" }}>
            {isSerial ? (
              <>
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <InputLabel id="demo-simple-select-autowidth-label">
                    زبان
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={subtitlesLanguage}
                    onChange={(e) => {
                      setSubtitlesLanguage(e.target.value);
                    }}
                    autoWidth
                    label="Age"
                  >
                    <MenuItem value="all">
                      <em>همه زبانها</em>
                    </MenuItem>
                    <MenuItem key={0} value="en">
                      English
                    </MenuItem>
                    <MenuItem key={1} value="de">
                      German
                    </MenuItem>
                    <MenuItem key={2} value="fr">
                      French
                    </MenuItem>
                    <MenuItem key={3} value="it">
                      Italian
                    </MenuItem>
                    <MenuItem key={4} value="tr">
                      Turkish
                    </MenuItem>
                    {Object.keys(languagesList).map((option, index) => (
                      <MenuItem key={index + 5} value={option}>
                        {languagesList[option]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <Typography>
            سریال : 
            </Typography> */}
                <TextField
                  value={season}
                  InputProps={{
                    inputProps: { min: "0", max: "1000", step: "1" },
                  }}
                  type="number"
                  onChange={(e) => {
                    if (e.target.value == 0) {
                      setSeason(null);
                    } else {
                      setSeason(e.target.value);
                    }
                  }}
                  sx={{ width: "100px", m: 0.5 }}
                  label="فصل"
                />
                <TextField
                  value={episode}
                  InputProps={{
                    inputProps: { min: "0", max: "1000", step: "1" },
                  }}
                  type="number"
                  onChange={(e) => {
                    if (e.target.value == 0) {
                      setEpisode(null);
                    } else {
                      setEpisode(e.target.value);
                    }
                  }}
                  sx={{ width: "100px", m: 0.5 }}
                  label="قسمت"
                />
              </>
            ) : null}
          </Box>
        </Paper>
      )}
      {subtitlesListPaginate["totalDocs"] > 0 ? (
        <Paper sx={{ mt: 0.5 }}>
          <Pagination
            onChange={handleChangePage}
            page={subtitlesListPaginate["page"]}
            count={subtitlesListPaginate["totalPages"]}
            variant="outlined"
            color="primary"
          />
        </Paper>
      ) : null}
    </>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
